import React, { ReactNode } from 'react'
import Navbar from 'components/Navbar'
import BlurLoading from 'components/Loading/BlurLoading'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { LOADING } from 'store/modules/loading/types'
import { CorpoConteudo } from './style'
import Footer from 'components/Footer'

interface LandingPageProps {
  children?: ReactNode
}

const LandingPage = ({ children }: LandingPageProps) => {
  const { isLoading } = useSelector<ApplicationState, LOADING>(
    (state) => state.loading
  )

  return (
    <>
      <BlurLoading isLoading={isLoading} />
      <Navbar />
      <CorpoConteudo rowGap="0">{children}</CorpoConteudo>
      <Footer />
    </>
  )
}

export default LandingPage
